module.exports = __webpack_public_path__ + "img/vartext3nyen.e9e563ec.svg";